import { render, staticRenderFns } from "./PButton.vue?vue&type=template&id=04e27f88&scoped=true&"
import script from "./PButton.vue?vue&type=script&lang=ts&"
export * from "./PButton.vue?vue&type=script&lang=ts&"
import style0 from "./PButton.vue?vue&type=style&index=0&id=04e27f88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e27f88",
  null
  
)

export default component.exports